<template>
	<div
		v-if="initialState !== null"
		:class="{
			'switch__wrapper--disabled': disabled
		}"
		class="switch__wrapper"
		data-cy="switch-wrapper"
	>
		<div
			v-if="alignment === 'left' && label"
			class="switch__labels switch__labels--left"
		>
			<div
				v-if="label"
				class="switch__label"
				@click.stop="toggleState"
			>
				{{ label }}
			</div>

			<div
				v-if="sublabel"
				class="switch__sublabel"
				@click.stop="toggleState"
			>
				{{ sublabel }}
			</div>
		</div>

		<button
			:class="{
				'switch--primary' : color === 'primary',
				'switch--off' : !state,
				'switch--on' : state,
				'is-animating' : animating,
			}"
			:disabled="disabled"
			class="switch"
			role="switch"
			type="button"
			:aria-label="label"
			:aria-checked="ariaChecked"
			data-cy="switch-toggler"
			@click.stop="toggleState"
		/>

		<div
			v-if="alignment === 'right' && label"
			class="switch__labels switch__labels--right"
		>
			<div
				v-if="label"
				class="switch__label"
				@click.stop="toggleState"
			>
				{{ label }}
			</div>

			<div
				v-if="sublabel"
				class="switch__sublabel"
				@click.stop="toggleState"
			>
				{{ sublabel }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SwitchComponent',

	props: {
		alignment: {
			type: String,
			required: false,
			default: 'left',
			validator: value => [
				'left',
				'right',
			].indexOf(value) !== -1,
			description: 'Sets the horizontal alignment of the Slider',
		},

		changeStateItself: {
			type: Boolean,
			required: false,
			default: true,
			description: 'Sets whether clicking on the Switch will change its own state',
		},

		color: {
			type: String,
			required: false,
			default: 'normal',
			validator: value => [
				'normal',
				'primary',
			].indexOf(value) !== -1,
			description: 'Sets the colour of the Switch',
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false,
			description: 'Sets whether the Switch will be disabled for the user',
		},

		initialState: {
			type: Boolean,
			required: false,
			default: null,
			description: 'Sets whether the Switch is initially on or off',
		},

		label: {
			type: String,
			required: false,
			default: null,
			description: 'Sets the Switch\'s label',
		},

		sublabel: {
			type: String,
			required: false,
			default: null,
			description: 'Sets the Switch\'s sublabel',
		},
	},

	data() {
		return {
			state: null,
			animating: false,
			ariaChecked: null,
		};
	},

	watch: {
		initialState() {
			this.state = this.initialState;
			this.ariaChecked = this.initialState;
			this.animate();
		},
	},

	created() {
		this.state = this.initialState;
		this.ariaChecked = this.initialState;
	},

	methods: {
		toggleState() {
			if (!this.disabled) {
				if (this.changeStateItself) {
					this.state = !this.state;
					this.ariaChecked = this.state;
					this.animate();
				}

				this.$emit('toggle');

				if (this.state) {
					this.$emit('on');
				} else {
					this.$emit('off');
				}
			}
		},

		animate() {
			this.animating = true;
			setTimeout(() => {
				this.animating = false;
			}, 250);
		},
	},
};
</script>

<style lang="scss" src="./switch.scss" />
